import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as firebase from 'firebase'; 

import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { teal500, teal700, teal900, deepPurple300, deepPurple400, deepPurple500, red } from 'material-ui/styles/colors';

import './index.css';
import App from './pages/App';
import store from './store';

// firebase.initializeApp({
//   "apiKey": "AIzaSyAgcC81-F1NstNuluM3dxQoUzYWjfo_5QE",
//   "databaseURL": "https://trimed-894e6.firebaseio.com",
//   "storageBucket": "trimed-894e6.appspot.com",
//   "authDomain": "trimed-894e6.firebaseapp.com",
//   "messagingSenderId": "357430029957",
//   "projectId": "trimed-894e6"
// });

//new account
firebase.initializeApp({
  apiKey: "AIzaSyD0li5jS30v8klj1y_cnTaJzXp84Tmw8JM",
  authDomain: "trimed-979b9.firebaseapp.com",
  databaseURL: "https://trimed-979b9.firebaseio.com",
  projectId: "trimed-979b9",
  storageBucket: "trimed-979b9.appspot.com",
  messagingSenderId: "168947144221"
});


const theme = getMuiTheme({
  palette: {
    primary1Color: teal500,
    primary2Color: teal700,
    primary3Color: teal900,
    accent1Color: deepPurple300,
    accent2Color: deepPurple400,
    accent3Color: deepPurple500,
    error: red,
  },
});


injectTapEventPlugin();
ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={theme}>
      <BrowserRouter>
          <App/>
      </BrowserRouter>
    </MuiThemeProvider>
  </Provider>, document.getElementById('root'));



// import registerServiceWorker from './registerServiceWorker';s
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js